

























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseCloser from "@/components/BaseCloser";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import PreviewSetButton from "../PreviewSetButton";

@Component({
  name: "PostFileThumbnail",
  components: { PreviewSetButton, LoadingThumbnail, BaseCloser, BaseIcon, BaseImage },
})
export default class PostFileThumbnail extends Vue {
  @Prop({ required: true })
  public readonly postFile!: PostFileData;

  @Prop({ default: null })
  public readonly public!: boolean | null;

  @Prop({ type: Boolean, default: true })
  public readonly removable!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly showPublicButton!: boolean;

  public get processingError() {
    return this.postFile.processingStatus === "ERROR";
  }

  public get isPublic() {
    if (this.public !== null) return this.public;
    return this.postFile.public;
  }

  public get icon() {
    if (isVideoFile(this.postFile)) return "sci-video";
    return "sci-image";
  }

  public get src() {
    if (!this.postFile.url) return "";
    if (isVideoFile(this.postFile)) return MediaFilesController.getVideoThumbnail(this.postFile.url, "480p");
    if (isImageFile(this.postFile)) return MediaFilesController.getImageThumbnail(this.postFile.url, "480p");
    return "";
  }

  public get duration() {
    if (this.postFile.duration) return getMediaDuration(this.postFile.duration);
    return "";
  }
}
